module.exports = __webpack_public_path__ + "static/img/ly-monitor.a452314.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/ly-monitor.svg
// module id = B0qB
// module chunks = 16